var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFollowWhite = function SvgIconFollowWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2324_2973)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M3.49 4.773a4.4 4.4 0 0 1 6.221 0l1.29 1.288 1.288-1.288a4.4 4.4 0 1 1 6.222 6.221l-7.51 7.512-7.512-7.512a4.4 4.4 0 0 1 0-6.221Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2324_2973"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v22H0z"
  })))));
};
export default SvgIconFollowWhite;